module.exports = __webpack_public_path__ + "static/media/pic3.527951d6.jpg";